module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0aed289656b9305b500b0e3efe867a5a.png";